import { render, staticRenderFns } from "./zuhaogamelist.vue?vue&type=template&id=12f61a58"
import script from "./zuhaogamelist.vue?vue&type=script&lang=js"
export * from "./zuhaogamelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports